import Link from 'next/link'
import Image from 'next/image'
import { Secondary, SectionLink, SectionTitle, MainWrapper, SmallLinks } from './ExozFooter.styles'
import { Main, VirginLogos, Menu, FooterTermsWrapper, Heading } from './VirginFooter.styles'
import { useElementClick } from '@/hooks/HTMLElementClickHook'
import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { Spacing } from '@big-red-group/storefront-common-ui'
import Container from './Container'

type MenuSection = {
  title: string
  links: { label: string; url: string; target?: '_blank' }[]
}

const VirginFooter = () => {
  const linkClick = useElementClick('Link')
  const privacyPolicyLinkTxt = 'Privacy'
  const defaultProperties = useContext(DefaultPropertiesContext)
  const handlerKey = defaultProperties?.agentConfiguration?.handlerKey
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)

  const menuSections: MenuSection[] = [
    {
      title: 'About',
      links: [
        { label: 'Experience Oz Terms & Conditions', url: `${baseUrl}/en/terms-and-conditions` },
        {
          label: 'Experience Oz Privacy Policy',
          url: `${baseUrl}/en/privacy-policy`,
        },
      ],
    },
    {
      title: 'Resources',
      links: [
        { label: 'Contact Experience Oz', url: `${baseUrl}/en/faqs` },
        {
          label: 'Manage Flights',
          url: 'https://www.virginaustralia.com/au/en/travel-info/bookings/',
          target: '_blank',
        },
      ],
    },
    {
      title: 'More',
      links: [
        { label: 'Return to Virgin Australia', url: 'https://www.virginaustralia.com/au/en', target: '_blank' },
        { label: 'Return to Velocity Frequent Flyer', url: 'https://www.velocityfrequentflyer.com/', target: '_blank' },
      ],
    },
  ]

  return (
    <>
      {/* <Container>
        <FooterTermsWrapper>
        </FooterTermsWrapper>
      </Container> */}
      <MainWrapper lightFooter data-testid="virgin-footer">
        <Spacing size="XXXL" />
        <Main>
          <Image src={`${baseUrl}/logos/exoz-logo-dark-mono.svg`} alt="Experience Oz" width={137} height={32} />
          <Menu>
            {menuSections.map(({ title, links }) => (
              <div key={title}>
                <SectionTitle>{title}</SectionTitle>
                {links.map(({ label, url, target }) => (
                  <SectionLink
                    data-testid={label}
                    href={url}
                    key={url}
                    target={target || '_self'}
                    onClick={(event) => linkClick({ location: `Footer | ${title}`, event })}
                  >
                    {label}
                  </SectionLink>
                ))}
              </div>
            ))}
          </Menu>
          <VirginLogos>
            <Link href="https://www.virginaustralia.com/au/en/#/" target="_blank">
              <Image src={`${baseUrl}/logos/virgin-logo-dark.svg`} alt="Virgin Australia" width={156} height={50} />
            </Link>
            <Link href="https://www.velocityfrequentflyer.com/" target="_blank">
              <Image
                src={`${baseUrl}/logos/velocity-logo-dark.svg`}
                alt="Velocity Frequent Flyer"
                width={136}
                height={50}
              />
            </Link>
          </VirginLogos>
        </Main>
        <Secondary>
          <SmallLinks>
            <span>&copy; Experience Oz</span>
            <span>
              <Link
                data-testid={privacyPolicyLinkTxt}
                href={`${baseUrl}/en/privacy-policy`}
                onClick={(event) => linkClick({ location: `Footer | ${privacyPolicyLinkTxt}`, event })}
              >
                {privacyPolicyLinkTxt}
              </Link>
            </span>
            {/* TODO Uncomment when sitemap created */}
            {/*<span>*/}
            {/*  <Link*/}
            {/*    data-testid={sitemapLinkTxt}*/}
            {/*    href="/en/sitemap"*/}
            {/*    onClick={(event) => linkClick({ location: `Footer | ${sitemapLinkTxt}`, event })}*/}
            {/*  >*/}
            {/*    {sitemapLinkTxt}*/}
            {/*  </Link>*/}
            {/*</span>*/}
            <span style={{ cursor: 'pointer' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              Back to Top
            </span>
          </SmallLinks>
          {/* Logo */}
          <Image src={`${baseUrl}/logos/brg-logo-dark.svg`} alt="Big Red Group" width={141} height={32} />
        </Secondary>
      </MainWrapper>
    </>
  )
}

export default VirginFooter
